export const availableWidgets = [
    {
        id: 'prospect_sessions',
        component: 'ProspectSessions',
        props: {
            paywall: true,
            titleKey: 'components.prospect_sessions.name'
        },
    },
    {
        id: 'prospect_ai_summary',
        component: 'ProspectAiWidget',
        props: { 
            slug: 'summary', 
            titleKey: 'components.prospect_ai.models.summary' 
        },
    },
    {
        id: 'prospect_firmology',
        component: 'ProspectFirmology',
        props: {
            titleKey: 'components.prospect_firmology.name'
        },
    },
    {
        id: 'prospect_contact_information',
        component: 'ProspectContactInfo',
        props: {
            titleKey: 'components.prospect_contact_information.name'
        },
    },
    {
        id: 'prospect_owner',
        component: 'ProspectAssignment',
        props: {
            paywall: true,
            titleKey: 'components.prospect_owner.name'
        },
    },
    {
        id: 'prospect_tags',
        component: 'ProspectTags',
        props: {
            titleKey: 'components.prospect_tags.name'
        },
    },
    {
        id: 'prospect_events',
        component: 'ProspectEvents',
        props: {
            titleKey: 'components.prospect_events.name'
        },
    },
    {
        id: 'prospect_contacts',
        component: 'ProspectContacts',
        props: {
            titleKey: 'components.prospect_contacts.name'
        },
    },
    {
        id: 'prospect_people',
        component: 'ProspectPeople',
        props: {
            paywall: true,
            titleKey: 'components.prospect_people.name'
        },
    },
    {
        id: 'prospect_ratings',
        component: 'ProspectReviewsSummary',
        props: { 
            paywall: true,
            titleKey: 'components.prospect_ratings.name' 
        },
    },
    {
        id: 'prospect_opening_hours',
        component: 'ProspectOpeningHours',
        props: { 
            paywall: true,
            titleKey: 'components.prospect_opening_hours.name' 
        },
    },
    {
        id: 'prospect_industries',
        component: 'ProspectIndustries',
        props: {
            paywall: true,
            titleKey: 'components.prospect_industries.name'
        },
    },
    {
        id: 'prospect_ai_fundamentals',
        component: 'ProspectAiWidget',
        props: { 
            slug: 'fundamentals', 
            paywall: true, 
            titleKey: 'components.prospect_ai.models.fundamentals' 
        },
    },
    {
        id: 'prospect_sitesearch',
        component: 'ProspectSiteSearch',
        props: { 
            paywall: true, 
            titleKey: 'components.prospect_sitesearch.name' 
        },
    },
    {
        id: 'prospect_family',
        component: 'ProspectFamily',
        props: {
            titleKey: 'components.prospect_family.name'
        },
    },
    {
        id: 'prospect_property',
        component: 'ProspectProperty',
        props: { 
            paywall: true, 
            titleKey: 'components.prospect_property.name' 
        },
    },
    {
        id: 'prospect_same_address',
        component: 'ProspectSameAddress',
        props: { 
            paywall: true, 
            titleKey: 'components.prospect_same_address.name' 
        },
    },
    {
        id: 'prospect_reviews',
        component: 'ProspectReviewsDetails',
        props: {
            paywall: true,
            titleKey: 'components.prospect_reviews.name'
        },
    },
    {
        id: 'prospect_news',
        component: 'ProspectNews',
        props: { 
            paywall: true, 
            titleKey: 'components.prospect_news.name' 
        },
    },
    {
        id: 'prospect_vacancies',
        component: 'ProspectVacancies',
        props: { 
            paywall: true, 
            titleKey: 'components.prospect_vacancies.name' 
        },
    },
    {
        id: 'prospect_apps',
        component: 'ProspectAppsDetails',
        props: { 
            paywall: true, 
            titleKey: 'components.prospect_apps.name' 
        },
    },
    {
        id: 'prospect_siterank',
        component: 'ProspectSiteRank',
        props: { 
            paywall: true, 
            titleKey: 'components.prospect_siterank.name' 
        },
    },
];

export const widgetPresets = [
    {
        id: 'default', // Prospecting
        widgets: [
            { id: 'prospect_sessions',            defaultToggle: true  },
            { id: 'prospect_ai_summary',          defaultToggle: true },
            { id: 'prospect_contact_information', defaultToggle: true  },
            { id: 'prospect_tags',                defaultToggle: true },
            { id: 'prospect_contacts',            defaultToggle: true  },
            { id: 'prospect_people',              defaultToggle: true },
            { id: 'prospect_firmology',           defaultToggle: false },
            { id: 'prospect_ai_fundamentals',     defaultToggle: false },
            { id: 'prospect_family',              defaultToggle: false },
            { id: 'prospect_owner',               defaultToggle: false },
            { id: 'prospect_events',              defaultToggle: false },
            { id: 'prospect_property',            defaultToggle: true },
            { id: 'prospect_same_address',        defaultToggle: true },
            { id: 'prospect_ratings',             defaultToggle: false },
            { id: 'prospect_opening_hours',       defaultToggle: false },
            { id: 'prospect_industries',          defaultToggle: false },
            { id: 'prospect_sitesearch',          defaultToggle: true  },
            { id: 'prospect_reviews',             defaultToggle: false },
            { id: 'prospect_news',                defaultToggle: true  },
            { id: 'prospect_vacancies',           defaultToggle: false  },
            { id: 'prospect_apps',                defaultToggle: true },
            { id: 'prospect_siterank',            defaultToggle: false },
        ],
    },
    {
        id: 'sales',
        widgets: [
            { id: 'prospect_sessions',            defaultToggle: true },
            { id: 'prospect_ai_summary',          defaultToggle: false },
            { id: 'prospect_contact_information', defaultToggle: true },
            { id: 'prospect_contacts',            defaultToggle: true },
            { id: 'prospect_tags',                defaultToggle: true },
            { id: 'prospect_events',              defaultToggle: true },
            { id: 'prospect_owner',               defaultToggle: true },
            { id: 'prospect_opening_hours',       defaultToggle: false },
            { id: 'prospect_firmology',           defaultToggle: false },
            { id: 'prospect_people',              defaultToggle: false },
            { id: 'prospect_family',              defaultToggle: false },
            { id: 'prospect_property',            defaultToggle: false },
            { id: 'prospect_same_address',        defaultToggle: false },
            { id: 'prospect_ai_fundamentals',     defaultToggle: false },
            { id: 'prospect_ratings',             defaultToggle: false },
            { id: 'prospect_industries',          defaultToggle: false },
            { id: 'prospect_sitesearch',          defaultToggle: false },
            { id: 'prospect_reviews',             defaultToggle: false },
            { id: 'prospect_news',                defaultToggle: false },
            { id: 'prospect_vacancies',           defaultToggle: false },
            { id: 'prospect_apps',                defaultToggle: false },
            { id: 'prospect_siterank',            defaultToggle: false },
        ],
    },
    {
        id: 'account_management',
        widgets: [
            { id: 'prospect_sessions',            defaultToggle: true },
            { id: 'prospect_tags',                defaultToggle: true },
            { id: 'prospect_events',              defaultToggle: true },
            { id: 'prospect_contacts',            defaultToggle: true },
            { id: 'prospect_contact_information', defaultToggle: true },
            { id: 'prospect_owner',               defaultToggle: false },
            { id: 'prospect_ai_summary',          defaultToggle: false },
            { id: 'prospect_opening_hours',       defaultToggle: false },
            { id: 'prospect_firmology',           defaultToggle: false },
            { id: 'prospect_people',              defaultToggle: false },
            { id: 'prospect_family',              defaultToggle: false },
            { id: 'prospect_property',            defaultToggle: false },
            { id: 'prospect_same_address',        defaultToggle: false },
            { id: 'prospect_ai_fundamentals',     defaultToggle: false },
            { id: 'prospect_ratings',             defaultToggle: false },
            { id: 'prospect_industries',          defaultToggle: false },
            { id: 'prospect_sitesearch',          defaultToggle: false },
            { id: 'prospect_reviews',             defaultToggle: false },
            { id: 'prospect_news',                defaultToggle: false },
            { id: 'prospect_vacancies',           defaultToggle: false },
            { id: 'prospect_apps',                defaultToggle: false },
            { id: 'prospect_siterank',            defaultToggle: false },
        ],
    },
];
